import { AiProduct } from 'components/goods/ai/AiProduct/AiProduct'
import { useParams } from 'react-router-dom'

export const AiGoodsEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <AiProduct productId={id as string} type='edit' />
}